import { useEffect } from 'react';

const DEFAULT_TITLE = 'idaNroh · Sache avant de partir à la gare';
const DEFAULT_DESC =
  'Avant de partir à la gare routière de Kharouba, sache si tu vas avoir une place. Départs en direct + prédiction d\'affluence SOGRAL depuis Alger.';

export function usePageMeta(title: string, description: string, keywords?: string) {
  useEffect(() => {
    document.title = title;

    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute('content', description);

    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute('content', title);
    const ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc) ogDesc.setAttribute('content', description);
    const twTitle = document.querySelector('meta[name="twitter:title"]');
    if (twTitle) twTitle.setAttribute('content', title);
    const twDesc = document.querySelector('meta[name="twitter:description"]');
    if (twDesc) twDesc.setAttribute('content', description);

    let kwEl = document.querySelector('meta[name="keywords"]');
    if (keywords) {
      if (!kwEl) {
        kwEl = document.createElement('meta');
        kwEl.setAttribute('name', 'keywords');
        document.head.appendChild(kwEl);
      }
      kwEl.setAttribute('content', keywords);
    }

    return () => {
      document.title = DEFAULT_TITLE;
      if (desc) desc.setAttribute('content', DEFAULT_DESC);
      if (ogTitle) ogTitle.setAttribute('content', DEFAULT_TITLE);
      if (ogDesc) ogDesc.setAttribute('content', DEFAULT_DESC);
      if (twTitle) twTitle.setAttribute('content', DEFAULT_TITLE);
      if (twDesc) twDesc.setAttribute('content', DEFAULT_DESC);
      if (kwEl) kwEl.setAttribute('content', '');
    };
  }, [title, description, keywords]);
}
